/**
 * Formatea números con el estándar español/argentino:
 * - Punto (.) para separar miles
 * - Coma (,) para separar decimales
 * - Siempre 2 decimales
 */

export const formatNumber = (value, decimals = 2) => {
  if (value === null || value === undefined || value === '') {
    return '0,00';
  }

  const num = typeof value === 'string' ? parseFloat(value) : value;

  if (isNaN(num)) {
    return '0,00';
  }

  return num.toLocaleString('es-AR', {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  });
};

/**
 * Convierte un string formateado a número
 * - Acepta punto como separador de miles
 * - Acepta coma como separador de decimales
 */
export const parseFormattedNumber = (value) => {
  if (typeof value !== 'string') {
    return value;
  }

  // Eliminar puntos (separadores de miles)
  // Reemplazar coma por punto (separador decimal)
  const cleaned = value.replace(/\./g, '').replace(',', '.');
  const num = parseFloat(cleaned);

  return isNaN(num) ? 0 : num;
};

/**
 * Formatea un input mientras el usuario escribe
 * Mantiene la posición del cursor
 */
export const formatInputNumber = (event) => {
  const input = event.target;
  let value = input.value;

  // Guardar posición del cursor
  const cursorPosition = input.selectionStart;

  // Eliminar todo excepto números, punto y coma
  value = value.replace(/[^\d.,]/g, '');

  // Reemplazar coma por punto para el parseo
  const numericValue = parseFloat(value.replace(/\./g, '').replace(',', '.'));

  if (!isNaN(numericValue)) {
    // Formatear el número
    const formatted = formatNumber(numericValue);
    input.value = formatted;

    // Restaurar posición del cursor aproximada
    const diff = formatted.length - value.length;
    input.setSelectionRange(cursorPosition + diff, cursorPosition + diff);
  }
};

/**
 * Hook personalizado para inputs numéricos formateados
 */
export const useFormattedNumber = (initialValue = 0) => {
  const formatForDisplay = (value) => formatNumber(value);
  const parseForCalculation = (value) => parseFormattedNumber(value);

  return {
    formatForDisplay,
    parseForCalculation,
    formatNumber,
  };
};
